import { ExternalLink, Instagram, Linkedin, MessageCircle } from 'lucide-react';

/**
 * Shortcuts to where a posting gets shared by hand.
 *
 * Links, and deliberately nothing more. Nothing is posted, no account is
 * connected, no credential is stored and no API is called — clicking one opens
 * the site in a new tab and the recruiter takes it from there. Said plainly on
 * the card, because a row of platform logos inside an ATS reads like an
 * integration, and somebody would reasonably assume their job had gone out.
 *
 * rel="noopener noreferrer" on every one. Without noopener the opened page
 * gets a handle on this tab through window.opener and can navigate it
 * somewhere else — the tabnabbing case — and it costs nothing to close.
 *
 * Lives on My Day rather than Job Postings. The links carry no posting
 * context — they are the three sites' front doors — so nothing tied them to
 * that page, and the start of the day is when somebody actually opens them.
 * A component rather than inline markup so it has one home if that changes.
 */
const SHARE_LINKS = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com', icon: Linkedin },
  { label: 'WhatsApp', href: 'https://web.whatsapp.com', icon: MessageCircle },
  { label: 'Instagram', href: 'https://www.instagram.com', icon: Instagram },
];

export default function ShareLinks() {
  return (
    <section className="card">
      <h3 className="text-sm font-semibold text-gray-900">Share a posting</h3>
      <p className="mt-1 text-xs text-gray-500">
        Opens each site in a new tab so you can post by hand. Nothing is shared
        automatically — this app posts nothing and stores no account details.
      </p>

      <div className="mt-3 grid gap-2 sm:grid-cols-3">
        {SHARE_LINKS.map(({ label, href, icon: Icon }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 rounded-lg border border-gray-200
                       px-3 py-2.5 text-sm font-medium text-gray-700 transition-colors
                       hover:border-indigo-300 hover:bg-indigo-50 hover:text-indigo-700"
          >
            <Icon className="h-4 w-4" />
            {label}
            <ExternalLink className="h-3 w-3 text-gray-400" />
          </a>
        ))}
      </div>
    </section>
  );
}
